var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSourceDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F9F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 11.8911V15.3332C21.6666 15.7999 21.6666 16.0333 21.7574 16.2116C21.8373 16.3684 21.9648 16.4958 22.1216 16.5757C22.2999 16.6666 22.5332 16.6666 22.9999 16.6666H26.442M23.3333 20.8332H16.6666M23.3333 24.1665H16.6666M18.3333 17.4998H16.6666M21.6666 11.6665H17.3333C15.9331 11.6665 15.2331 11.6665 14.6983 11.939C14.2279 12.1787 13.8454 12.5611 13.6057 13.0315C13.3333 13.5663 13.3333 14.2664 13.3333 15.6665V24.3332C13.3333 25.7333 13.3333 26.4334 13.6057 26.9681C13.8454 27.4386 14.2279 27.821 14.6983 28.0607C15.2331 28.3332 15.9331 28.3332 17.3333 28.3332H22.6666C24.0667 28.3332 24.7668 28.3332 25.3016 28.0607C25.772 27.821 26.1544 27.4386 26.3941 26.9681C26.6666 26.4334 26.6666 25.7333 26.6666 24.3332V16.6665L21.6666 11.6665Z",
    stroke: "#6172F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceDefault);
export default __webpack_public_path__ + "static/media/source_default.83949bf3.svg";
export { ForwardRef as ReactComponent };